const SPLIT_TARGET_MODE = {
    New: "new",
    Existing: "existing",
};
const HEADER_ORIGINAL_SCHEMA = [
    {
        groupId: 1,
        label: "Original",
        fields: [
            { name: "TransactionNumber", label: "Transaction #", type: "text", visible: true, readOnly: true },
            { name: "ShippingDate", label: "Ship Date", type: "date", visible: true, readOnly: true },
            { name: "Stage", label: "Stage", type: "select", visible: true, readOnly: true },
            { name: "TransactionDate", label: "Transaction Date", type: "date", visible: true, readOnly: true },
            { name: "Reference", label: "Reference", type: "text", visible: true, readOnly: true },
            { name: "Comment", label: "Comment", type: "textarea", visible: true, readOnly: true },
            { name: "CustomerIdentityId", label: "Customer", type: "text", visible: true, readOnly: true },
            { name: "CustomerName", label: "Cust Name", type: "text", visible: true, readOnly: true },
            { name: "ShipToCode", label: "Ship To", type: "text", visible: true, readOnly: true },
            { name: "ShipToName", label: "Ship To Nm", type: "text", visible: true, readOnly: true },
        ],
    },
];

const HEADER_SPLIT_SCHEMA = [
    {
        groupId: 1,
        label: "Split/Now",
        fields: [
            { name: "TransactionNumberNew", label: "Transaction #", type: "text", visible: true, readOnly: true },
            { name: "ShippingDateNew", label: "Ship Date", type: "date", visible: true, readOnly: false },
            { name: "StageNew", label: "Stage", type: "select", visible: true, readOnly: false },
            { name: "TransactionDateNew", label: "Transaction Date", type: "date", visible: true, readOnly: false },
            { name: "ReferenceNew", label: "Reference", type: "text", visible: true, readOnly: false },
            { name: "CommentNew", label: "Comment", type: "textarea", visible: true, readOnly: false },
            { name: "CustomerIdentityIdNew", label: "Customer", type: "text", visible: true, readOnly: false },
            { name: "CustomerNameNew", label: "Cust Name", type: "text", visible: true, readOnly: true },
            { name: "ShipToCodeNew", label: "Ship To", type: "text", visible: true, readOnly: false },
            { name: "ShipToNameNew", label: "Ship To Nm", type: "text", visible: true, readOnly: true },
        ],
    },
];

const DETAIL_UDF_ORIGINAL_SCHEMA = [
    {
        groupId: 1,
        label: "Original",
        fields: [
            { name: "ReferenceNumber", label: "Reference #", type: "text", visible: true, readOnly: true },
            { name: "UserDefinedCode1", label: "Code 1", type: "text", visible: true, readOnly: true },
            { name: "UserDefinedQuantity1", label: "Quantity 1", type: "number", visible: true, readOnly: true },
            { name: "UserDefinedDate1", label: "Date 1", type: "date", visible: true, readOnly: true },
            { name: "UserDefinedReference1", label: "Reference 1", type: "text", visible: true, readOnly: true },
            { name: "UserDefinedComment", label: "COMMENT", type: "textarea", visible: true, readOnly: true },
            { name: "Comment", label: "Detail Comment", type: "textarea", visible: true, readOnly: true },
        ],
    },
];

const DETAIL_UDF_SPLIT_SCHEMA = [
    {
        groupId: 1,
        label: "Split/Now",
        fields: [
            { name: "ReferenceNumberNew", label: "Reference #", type: "text", visible: true, readOnly: false },
            { name: "UserDefinedCode1New", label: "Code 1", type: "text", visible: true, readOnly: false },
            { name: "UserDefinedQuantity1New", label: "Quantity 1", type: "number", visible: true, readOnly: false },
            { name: "UserDefinedDate1New", label: "Date 1", type: "date", visible: true, readOnly: false },
            { name: "UserDefinedReference1New", label: "Reference 1", type: "text", visible: true, readOnly: false },
            { name: "UserDefinedCommentNew", label: "COMMENT", type: "textarea", visible: true, readOnly: false },
            { name: "CommentNew", label: "Detail Comment", type: "textarea", visible: true, readOnly: false },
        ],
    },
];
const SPLIT_METHOD_SCHEMA = [
    {
        groupId: 1,
        label: "",
        fields: [
            {
                name: "SplitMethod",
                tableName: "OMSplitMethod",
                label: "",
                type: "radio",
                visible: true,
                readOnly: false,
                isLabelChanged: true,
                options: [
                    { value: SPLIT_TARGET_MODE.New, text: "Create a new order" },
                    {
                        value: SPLIT_TARGET_MODE.Existing,
                        text: "Add to an existing split order for the current order",
                    },
                ],
            },
        ],
    },
];
const TRANSACTION_DETAIL_SCHEMA = [
    {
        groupId: 1,
        label: "",
        fields: [
            { name: "RecordNumber", tableName: "OMTransactionHeader", label: "Record #", type: "text", visible: true, readOnly: true, isLabelChanged: false },
            { name: "IdentityId", tableName: "OMTransactionHeader", label: "Customer", type: "text", visible: true, readOnly: true, isLabelChanged: false },
            { name: "TransactionNumber", tableName: "OMTransactionHeader", label: "Transaction #", type: "text", visible: true, readOnly: true, isLabelChanged: false },
            { name: "StageDisplay", tableName: "OMTransactionHeader", label: "Stage", type: "text", visible: true, readOnly: true, isLabelChanged: false },
            { name: "StatusDisplay", tableName: "OMTransactionHeader", label: "Status", type: "text", visible: true, readOnly: true, isLabelChanged: false },
            { name: "OrderDate", tableName: "OMTransactionHeader", label: "Order Date", type: "date", visible: true, readOnly: true, isLabelChanged: false },
        ],
    },
];

export { HEADER_ORIGINAL_SCHEMA, HEADER_SPLIT_SCHEMA, DETAIL_UDF_ORIGINAL_SCHEMA, DETAIL_UDF_SPLIT_SCHEMA, SPLIT_METHOD_SCHEMA, TRANSACTION_DETAIL_SCHEMA,SPLIT_TARGET_MODE };